import { createContext, useContext } from "react"

const BankPricesContext = createContext()

export const useBankPricesContext = () => useContext(BankPricesContext)

export default BankPricesContext
